var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavOcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.799,
    height: 21,
    viewBox: "0 0 25.799 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699",
    transform: "translate(-1272.6 -5921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_199",
    "data-name": "Union 199",
    d: "M1102-2423a3.142,3.142,0,0,1-2.315-.787,3.2,3.2,0,0,1-.781-2.339v-5.974h1.758v5.9a1.5,1.5,0,0,0,.365,1.08,1.462,1.462,0,0,0,1.091.374h10.127a1.491,1.491,0,0,0,1.1-.374,1.481,1.481,0,0,0,.369-1.08v-5.9h1.75v5.974a3.206,3.206,0,0,1-.778,2.339,3.136,3.136,0,0,1-2.319.787Zm-7.1-9.6a.9.9,0,0,1-.9-.9.9.9,0,0,1,.9-.9h24a.9.9,0,0,1,.9.9.9.9,0,0,1-.9.9Zm5.758-2.3H1098.9v-5.966a3.218,3.218,0,0,1,.781-2.344A3.131,3.131,0,0,1,1102-2444h4.662a4.585,4.585,0,0,1,1.44.191,3.052,3.052,0,0,1,1.152.789l5.242,5.326a3.831,3.831,0,0,1,.617.789,2.478,2.478,0,0,1,.28.824,7.13,7.13,0,0,1,.074,1.11v.07h-7.948a1.569,1.569,0,0,1-.666-.383,2.012,2.012,0,0,1-.489-1.473v-5.486h-4.238a1.465,1.465,0,0,0-1.1.38,1.485,1.485,0,0,0-.369,1.075v5.888h0Zm7.282-2.045a.589.589,0,0,0,.133.427.589.589,0,0,0,.427.133h4.934l-5.495-5.579Z",
    transform: "translate(178.6 8365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7_-_Outline",
    "data-name": "Subtraction 7 - Outline",
    d: "M1101.4-2431.6v5.474a2.731,2.731,0,0,0,.636,1.987,2.672,2.672,0,0,0,1.96.639h10.37a2.668,2.668,0,0,0,1.963-.638,2.741,2.741,0,0,0,.634-1.988v-5.474h-.75v5.4a1.958,1.958,0,0,1-.513,1.431,1.966,1.966,0,0,1-1.46.523h-10.127a1.937,1.937,0,0,1-1.449-.526,1.971,1.971,0,0,1-.506-1.428v-5.4Zm0-3.8h.758v-5.388a1.964,1.964,0,0,1,.51-1.423,1.939,1.939,0,0,1,1.454-.531h4.738v5.986a1.547,1.547,0,0,0,.342,1.12,1.037,1.037,0,0,0,.391.237h7.359a5.47,5.47,0,0,0-.058-.6,1.979,1.979,0,0,0-.222-.658,3.354,3.354,0,0,0-.539-.685l-5.241-5.325a2.57,2.57,0,0,0-.956-.666,4.113,4.113,0,0,0-1.279-.164H1104a2.662,2.662,0,0,0-1.959.641,2.748,2.748,0,0,0-.637,1.992Zm15.227-.483H1110.5a1.061,1.061,0,0,1-.781-.28,1.06,1.06,0,0,1-.28-.781v-6.239Z",
    transform: "translate(176.599 8365)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavOcr);
export default __webpack_public_path__ + "static/media/Nav-OCR.b1404316c1599b07c271babf93b47457.svg";
export { ForwardRef as ReactComponent };